import { createSwiper } from './swiper';

const initSection = (section) => {
  const carousel = section.querySelector('.featured-promo-cards__swiper');
  if (!carousel) return;

  let instance = null;

  const destroy = () => {
    if (instance) {
      instance.destroy(true, true);
      instance = null;
    }
  };

  instance = createSwiper(carousel, {
    lazy: true,
    slideClass: 'featured-promo-cards__card',
    wrapperClass: 'featured-promo-cards__wrapper',
    slidesPerView: 'auto',
    spaceBetween: 8,
    grabCursor: true,
    navigation: {
      nextEl: carousel.querySelector('.featured-promo-cards__nav-btn--next'),
      prevEl: carousel.querySelector('.featured-promo-cards__nav-btn--prev'),
    },
    breakpoints: {
      768: {
        spaceBetween: 16,
      },
    },
    a11y: { enabled: true },
  });

  return destroy;
};

const featuredPromoCards = () => {
  const destroyers = new Map();

  document.querySelectorAll('.featured-promo-cards').forEach((section) => {
    const destroy = initSection(section);
    if (destroy) destroyers.set(section.id, destroy);
  });

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.featured-promo-cards');
    if (section) {
      const destroy = initSection(section);
      if (destroy) destroyers.set(section.id, destroy);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector('.featured-promo-cards');
    if (section && destroyers.has(section.id)) {
      destroyers.get(section.id)();
      destroyers.delete(section.id);
    }
  });
};

export default featuredPromoCards;
